module.exports = __webpack_public_path__ + "static/media/campaigns.d52a3d7c.png";